import { Asset } from 'expo-asset';
import { fromPromise } from 'xstate5';

// ─────────────────────────────────────────────────────────────────────────────

export const downloadAsset = fromPromise<
  DownloadAssetOutput,
  DownloadAssetInput
>(async (args) => {
  const { url } = args.input;

  const assets = await Asset.loadAsync([url]);
  const asset = assets[0];

  const localURI = asset?.localUri;

  if (!localURI) {
    throw new Error(`Failed to download asset | URL: ${url}`);
  }

  return { localURI };
});

// ─── Types ───────────────────────────────────────────────────────────────────

type DownloadAssetInput = {
  url: string;
};

type DownloadAssetOutput = {
  localURI: string;
};
